export default __webpack_public_path__ + "media/pandemicMockup.c31afd4f.webm";